<template>
    <div class="header clearfix">
        <div class="container">
            <div class="logo" v-bd-track-event="['首页', '点击左上角旋涡营销LOGO']">
                <!--<router-link to="/index"><img src="../content/images/logo.png" alt="漩涡营销"></router-link>-->
                <a target="_blank" href="https://www.xuanwo001.com/"><img src="../content/images/logo.png" alt="漩涡营销"></a>
            </div>

            <ul class="fl nav clearfix">
                <li v-for="(item, index) in nav" :key="index" :class="isActive(item)" @click="onNavClick(item)" v-bd-track-event="['首页', '点击导航栏的' + item.name]">
                    <a>{{item.name}}</a>
                </li>
                <li class="nav-toolkit pop-toolkit" @mouseover="onMouseOver" @mouseout="onMouseOut" v-bd-track-event="['首页', '点击导航栏的工具箱']">
                    <a>营销工具</a>
                </li>
          <!--      <li class="nav-toolkit pop-toolkit" :class="isActive({to:'/exam'})"  v-bd-track-event="['首页', '点击导航栏的考试']" @click="onNavClickExam('考试')">

                    <a class="lineBlock">考试</a>
                </li>-->
        <!--        <router-link class="other-item" :class="{'active': /^\/exam/.test($route.path)}" to="/exam" >

                </router-link>-->
            </ul>

            <div class="other">
                <router-link class="other-item" :class="{'active': /^\/welfare/.test($route.path)}" to="/welfare"  v-bd-track-event="['首页', '点击福利中欧冠新']">
                    <span class="member-icon-imgs" style="display: inline-block"><img src="../content/images/welfare/welfare-icon.png" style="width: 23px;"/></span>
                    <p class="lineBlock">福利中心</p>
                </router-link>
                <router-link class="other-item" :class="{'active': /^\/member/.test($route.path)}" to="/member"  v-bd-track-event="['首页', '点击会员特权']">
                    <span class="member-icon-imgs" ><img src="../content/images/member/member-icon.png"/></span>
                    <p class="lineBlock">会员特权</p>
                </router-link>




                <router-link class="other-item" :class="{'active': /^\/user\/message/.test($route.path)}" to="/user/message" v-bd-track-event="['首页', '点击导航栏的消息']">
                    <el-badge class="badge" :hidden="!!!newTotal" :value="newTotal" :max="99" />
                    <span class="x-icon icon-notice"></span>
                    <p class="lineBlock">消息</p>
                </router-link>
            </div>

            <user></user>
        </div>

        <ul class="down-menu pop-toolkit" :class="{'hover': downMenu}" @mouseover="onMouseOver" @mouseout="onMouseOut">
            <li @click="onNavClick({to: '/stopword'})" v-bd-track-event="['首页', '通过工具箱点击广告禁用词']">
                <img src="../content/images/toolkit/toolkit-ad-law.png" alt="广告禁用词">
                <p class="textEllipsis">广告禁用词</p>
            </li>
            <li @click="onNavClick({to: '/xenu'})" v-bd-track-event="['首页', '通过工具箱点击死链检测']">
                <img src="../content/images/toolkit/toolkit-xenu.png" alt="网站死链检测">
                <p class="textEllipsis">网站死链检测</p>
            </li>
            <li @click="onNavClick({to: '/include'})" v-bd-track-event="['首页', '点击工具箱的网站收录查询']">
                <img src="../content/images/toolkit/toolkit-icon-iclude.png" alt="网站收录查询">
                <p class="textEllipsis">网站收录查询</p>
            </li>
            <li @click="onNavClick({to: '/keywords'})" v-bd-track-event="['首页', '点击工具箱的关键词排名查询']">
                <img src="../content/images/toolkit/toolkit-icon-ranking.png" alt="关键字排名查询">
                <p class="textEllipsis">关键字排名查询</p>
            </li>
            <li @click="onNavClick({to: '/densityIndex'})" v-bd-track-event="['首页', '点击导航栏的关键词密度查询']">
                <img src="../content/images/toolkit/density-icon.png" alt="关键词密度查询">
                <p class="textEllipsis">关键词密度查询</p>
            </li>
            <li @click="onNavClick({to: '/exam'})" v-bd-track-event="['首页', '点击导航栏的考试']">
                <img src="../content/images/toolkit/exam-icon.png" alt="营销能力评估">
                <p class="textEllipsis">营销能力评估</p>
            </li>

        </ul>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import User from './User.vue';
export default {
    components: {
        User
    },
    data () {
        return {
            nav: [
                {name: '网站诊断', to: '/index'},
                {name: '在线学习', to: '/study/course'}
//                    {name: '营销管家', to: '/market'}
            ],
            activeIndex: 0,

            downMenu: false
        }
    },
    computed: {
        ...mapState('message', ['newTotal']),
        ...mapState(['user', 'checkStatus']),
        showToolkitMenu: function() {
            return ['detail', 'exam-answer', 'study-detail'].indexOf(this.$route.name) === -1 && !this.checkStatus;
        }
    },
    created() {
        this.updateMessage();
    },
    methods: {
        ...mapActions(['postActionLog']),
        ...mapActions('message', ['updateMessage']),
        isActive(item) {
            console.log(item)
            let classifyRoute = item.to.match(/^\/[a-z]*/)[0];
            classifyRoute = classifyRoute === '/index' ? '\/(index|detail)$' : classifyRoute;
            return new RegExp(classifyRoute).test(this.$route.path) ? 'active' : '';
        },
        onNavClickExam (val){
            this.$router.push({path:'/exam'})
        },
        onNavClick(item){
            // 添加点击记录
            if (this.user._id && item.name === '在线学习' && this.$route.path !== '/study/course') {
                this.postActionLog({
                    category: '在线学习',
                    action: '点击',
                    optLabel: '在线学习',
                    userId: this.user._id
                })
            }
            this.onMouseOut();
            this.$router.push(item.to);
        },
        onMouseOver() {
            if (this.downMenuOut) return;
            this.downMenu = true
        },
        onMouseOut(event) {
            if (!event) { // 强制关闭
                this.downMenu = false;
                this.downMenuOut = true;
                setTimeout(() => {
                    this.downMenuOut = false;
                }, 500);
                return;
            }
            let $el = event.target || event;
            let className = $el.className;
            if (className.indexOf('header') === -1) {
                this.onMouseOut($el.parentElement);
            } else {
                this.downMenu = className.indexOf('pop-toolkit') !== -1;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    $height: 70px;
    .member-icon-imgs{
        img{
            width: 34px;
            vertical-align: -webkit-baseline-middle;
        }
    }
    .header {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: $height;
        z-index: 99;

        .container {
            position: relative;
            z-index: 2;
            height: 100%;
            background: #1f1f20;
        }

        .logo {
            position: absolute;
            top: 0;
            left: 0;
            width: 180px;
            height: 100%;
            padding: 12px 0;
            text-align: center;
            img {
                height: 100%;
            }
        }

        .nav {
            height: 100%;
            font-size: 14px;
            padding-left: 180px;
            & > li {
                float: left;
                width: 100px;
                height: 100%;
                line-height: $height;
                text-align: center;
                box-sizing: border-box;
                a {
                    display: block;
                    color: rgba(228, 229, 240, 0.5);
                }
                &:hover, &.active {
                    background: #262627;
                    border-bottom: 4px solid #2472e8;
                    cursor: pointer;
                    a {
                        color: #fff;
                    }
                }
            }
            .router-link-active {
                font-weight: 700;
                color: #fff !important;
            }
        }

        .other {
            position: absolute;
            right: 10rem;
            top: 50%;
            margin-top: -15px;
        }

        .other-item {
            position: relative;
            display: inline-block;
            color: #fff;
            margin-left: 25px;
            &:first-child {
                margin-left: 0;
            }
            > * {
                vertical-align: middle;
            }
            .x-icon {
                font-size: 24px;
            }
            p {
                font-size: 14px;
                margin: 0;
            }
            .badge {
                position: absolute;
                top: -5px;
                left: 1rem;
                z-index: 2;
            }
            span, p {
                opacity: .6;
            }
            &:hover *, &.active * {
                opacity: 1;
            }
        }
    }
    .el-menu-item {
        font-size: 18px;
    }

    /* 工具箱菜单 */
    .down-menu {
        visibility: hidden;
        position: fixed;
        top: $height;
        left: 0;
        width: 100%;
        height: 260px;
        padding: 56px 0 0 380px;
        padding-left: 0;
        text-align: left;
        justify-content:center;
        display: flex;
        background-color: #fbf8f7;
        box-shadow: 0 5px 5px 0 rgba(31, 31, 32, .1);
        transform: translate(0, -260px);
        transition: all .2s ease .3s;
        &.hover {
            visibility: visible;
            transform: translate(0, 0) !important;
        }
        li {
            display: inline-block;

            font-size: 16px;
            color: #76767b;
            text-align: center;
            vertical-align: top;
            margin-left: 90px;
            cursor: pointer;
            transition: all .3s linear;
            &:first-child {
                margin-left: 0;
            }
            img {
                display: block;
                width: 110px;
                border-radius: 25%;
                box-shadow: 0 0 10px rgba(195,195,195,.6);
            }
            p {
                margin: 22px 0 0;
                line-height: 1;
            }
            &:hover {
                transform: scale(1.1);
            }
        }
    }
</style>
<style>
    .header .el-badge__content {
        border: 0;
    }
</style>



// WEBPACK FOOTER //
// app/components/Header.vue